import React from "react";
import ListadoGeneralDia from "./listadoGeneralDia/listadoGeneralDia";
import ListadoEnvivo from "./listado/listado";
import "./envivo.sass";

export default function Envivo({ seccion, numCards, tipo, verListado, targetB, showFilter, fechaProp }) {

    return (
        <>
            {Number(tipo) === 1 ?
                <ListadoGeneralDia seccion={seccion} targetB={targetB} showFilter={showFilter} fechaProp={fechaProp}/>
                : Number(tipo) === 2 &&
                <ListadoEnvivo seccion={seccion} numCards={numCards} verListado={verListado} targetB={targetB}/>
            }
        </>
    )
}